import getStore from '../store/store';
import { createDisplayDate } from 'owa-datetime';
import { mutator } from 'satcheljs';
import setStartTime from '../../actions/setStartTime';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';
/**
 * Function to mutate the start time.
 */
export default mutator(setStartTime, function (actionMessage) {
    var date = actionMessage.dateTime;
    var optionState = getStore().currentState;
    var initialState = getStore().initialState;
    if (optionState.startDate) {
        var curStart = optionState.startDate;
        var startHours = date.getHours();
        var startMinutes = date.getMinutes();
        var startYear = curStart.getFullYear();
        var startMonth = curStart.getMonth();
        var startDate = curStart.getDate();
        // Set new start
        var newStart = createDisplayDate(startYear, startMonth, startDate, startHours, startMinutes);
        optionState.startDate = newStart;
    }
    else {
        var initialStart = initialState.startDate;
        var startHours = date.getHours();
        var startMinutes = date.getMinutes();
        var startYear = initialStart.getFullYear();
        var startMonth = initialStart.getMonth();
        var startDate = initialStart.getDate();
        // Set new start
        var newStart = createDisplayDate(startYear, startMonth, startDate, startHours, startMinutes);
        optionState.startDate = newStart;
    }
    optionState.endDate = getEndDateAfterModifications();
});
//# sourceMappingURL=setStartTime.js.map